import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION4: PdfComponent = {
  type: 'section',
  id: 'iars4',
  title: '4. Compliance and Conduct',
  content: [
    {
      type: 'bulletList',
      id: 'iars4bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'The Introducer shall:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Ensure all persons acting on its behalf comply with applicable regulations;',
              },
              {
                copy: 'Follow all instructions issued by the Principal regarding FCA compliance;',
              },
              {
                copy: 'Not bring the Principal into disrepute or cause it to breach FCA rules.',
              },
            ],
          },
        },
        {
          copy: 'The Introducer must disclose to clients that it is acting in the capacity of an appointed representative of the Principal.',
        },
      ],
      prefix: '4',
    },
  ],
};
